<template>
  <div class="text-center" v-if="loading">
    <button type="button" class="btn btn-default"><i class="fa fa-spinner fa-spin"></i> {{ msg ? msg : 'Carregando dados' }}...</button>
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: ['loading', 'msg']
};
</script>
<style lang="sass" scoped>
div
  padding-top: 30px
</style>
